import { Reveal, SectionTag, SectionTitle } from "./shared";
import { INSIGHTS } from "../data/site";
import { ArrowUpRight } from "lucide-react";
import { toast } from "sonner";

export function Insights() {
  return (
    <section id="insights" className="relative py-28 lg:py-40 bg-[#0D0D0D]" data-testid="insights-section">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <SectionTag>Market Intelligence</SectionTag>
        <div className="flex flex-wrap items-end justify-between gap-6 mb-14">
          <SectionTitle>RADIANCE <span className="text-gold-gradient italic">INSIGHTS</span></SectionTitle>
          <Reveal delay={0.15}>
            <p className="text-[11px] uppercase tracking-[0.3em] text-[#71717A]">An Investment Research Journal</p>
          </Reveal>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-[#D4AF37]/12 border border-[#D4AF37]/12" data-testid="insights-grid">
          {INSIGHTS.map((a, i) => (
            <Reveal key={a.title} delay={(i % 4) * 0.07}>
              <button
                data-testid={`insight-card-${i}`}
                onClick={() => toast.info("Full research notes are shared with registered clients. Speak to an advisor to receive this brief.")}
                className="group w-full h-full text-left bg-[#0D0D0D] p-7 flex flex-col hover:bg-[#141414] transition-colors duration-500"
              >
                <p className="text-[10px] uppercase tracking-[0.25em] text-[#D4AF37] mb-5">{a.tag}</p>
                <h3 className="font-serif-lux text-xl text-[#F5F5F0] leading-snug group-hover:text-[#F3E5AB] transition-colors flex-1">{a.title}</h3>
                <div className="flex items-center justify-between mt-8">
                  <span className="text-[10px] uppercase tracking-[0.2em] text-[#71717A]">{a.read} read</span>
                  <ArrowUpRight size={15} className="text-[#3f3f46] group-hover:text-[#D4AF37] transition-colors" />
                </div>
              </button>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
